// @flow

import React, { type Node } from 'react';

import styled from 'styled-components';
import { VoucherTicket } from '../../commons/voucher/ticket';
import { Cell, Title } from '../../commons/voucher/ticket/ticket';

import { timesGroupSplitter } from '@tectonics/look-and-feel/commons/format-utils';
import { getGatewayVoucherCode, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';

export function EfectyPaymentIntructions(): Node {
  const incomingPayment = usePendingIncomingPayment();

  return (
    <>
      <InstructionsTitle>Dicta las siguientes informacciones al cajero para realizar tu pago:</InstructionsTitle>

      <VoucherTicket>
        <Cell>
          <Title>Convenio EBANX</Title>
          <Value>
            111 856
          </Value>
        </Cell>
        <Cell>
          <Title>Codigo de Pago</Title>
          <Value>
            {timesGroupSplitter(4, getGatewayVoucherCode(incomingPayment)).map((code, _) => (
              code + ' '
            ))}
          </Value>
        </Cell>
      </VoucherTicket>
    </>
  );
}

const InstructionsTitle = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  text-align: center;

  color: #666666;
`;

const Value = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 27px;

  letter-spacing: 0.3px;

  color: #666666;
`;
